export const OPEN_CASH_DRAWER = 'peripheralDevices/OPEN_CASH_DRAWER';
export const openCashDrawer = (payload) => ({
  type: OPEN_CASH_DRAWER,
  payload,
});
